import React, { useState } from 'react';
import { FormattedMessage } from "react-intl"
import { useNavigate, Link } from "react-router-dom";
import axios from 'axios';
import { ThreeDots } from 'react-loader-spinner';

import Subtitle from '../components/UI/Subtitle'
import BaseInput from '../components/UI/BaseInput'

const PasswordReset = () => {

    const [email, setEmail] = useState("")
    const [reset, setReset] = useState(false)
    const [error, setError] = useState(false)
    const navigate = useNavigate()

    const handleSubmit = async (e) => {
        e.preventDefault();

        const formData = new FormData();
        formData.append('email', email)

        try {
            const headers = {
                headers: {}
            };
            const data = axios.post(process.env.REACT_APP_API_ENDPOINT + `/users/password/reset`, formData, headers)
            data.then(res => {
                if (res?.data?.verification_code?.length === 6) {
                    setReset(true)
                    setTimeout(() => {
                        navigate('/app/password-verification-token')
                    }, 1000);
                } else if (res?.data?.status === "ko") {
                    setError(true)
                }
            })
        } catch (err) {
            //console.log(err);
        }

    }

    return (
        <div className="p-4 flex flex-col items-center mt-20">
            {!reset ? (
                <form onSubmit={handleSubmit} className="flex flex-col gap-4" style={{ minWidth: '400px' }}>
                    <Subtitle><FormattedMessage id="app.reset.title" defaultMessage="Email" /></Subtitle>
                    <p><FormattedMessage id="app.reset.helpText" defaultMessage="We'll email you instructions to reset your password." /></p>
                    <BaseInput value={email}
                        onChange={(e) => setEmail(e.currentTarget.value)}
                        placeholder="Email"
                    />
                    <button className='w-full inline-block bg-blue-900 text-center text-white font-medium rounded-xl p-2' type='submit'>
                        Reset Password
                    </button>
                    <p className='text-end'><FormattedMessage id="app.reset.returnTo" defaultMessage="return to" /> <Link className='text-blue-900 font-bold underline' to="/app/login">
                        <FormattedMessage id="app.reset.returnToLogin" defaultMessage="login" /></Link></p>
                    {error && <div className='text-red-500 text-center'><FormattedMessage id="app.reset.emailNotFound" defaultMessage="User email not found" /></div>}
                </form>
            ) : (<div>
                <FormattedMessage id="app.reset.checkInbox" defaultMessage="Check your inbox" />
                <div className="col-span-6 mt-12 flex justify-center items-center">
                    <ThreeDots
                        height="80"
                        width="80"
                        radius="9"
                        color="#2f4d44"
                        ariaLabel="three-dots-loading"
                        wrapperStyle={{}}
                        wrapperClassName=""
                        visible={true}
                    />
                </div>
            </div>)
            }
        </div >
    );
};

export default PasswordReset;